<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1">Six Crystal Princesses</p>
<p class="ORIM-Subtitle">A Xanth novel</p>
<p class="ORIM-Subtitle">Piers Anthony</p>
<p class="ORIM-Subtitle"><img alt="logo" src="image/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Anthony_SixCrystal_1P_MD_epub-2.vue?be8f092c